// todo: could make this a function and just pass in the needed params
const getAdditionalAdders = (
  proposal,
  dealerFee,
  battery10Amount,
  mspAmount,
  freePowerAmount,
  ballastAmount,
  critterGuardAmount,
  groundMountAmount,
  pSolarAmount,
  customer
) => {
  return [
    {
      condition: proposal.sustainable === "1",
      adder: { adder: "portlandAdder", amount: proposal.systemSize * 0.34 },
    },
    { condition: +proposal.townhome === 1, adder: { adder: "townhome" } },
    {
      condition: proposal.pvSystemAddOn === "1",
      adder: {
        adder: "pvSystemAddOn",
        amount: 1000 / dealerFee,
      },
    },
    {
      condition: +proposal.modCount <= 5,
      adder: {
        adder: "smallSystem5AndUnder",
        amount: 2000 / dealerFee,
      },
    },
    {
      condition: +proposal.modCount > 5 && +proposal.modCount <= 7,
      adder: {
        adder: "smallSystem7or6",
        amount: 1000 / dealerFee,
      },
    },
    {
      condition: +proposal.modCount > 7 && +proposal.modCount <= 9,
      adder: {
        adder: "smallSystem8or9",
        amount: 500 / dealerFee,
      },
    },
    { condition: proposal.ionRebate === "2", adder: { adder: "repAdder" } },
    {
      condition: proposal.ionRebate === "1",
      adder: { adder: "custAdder" },
    },
    {
      condition: proposal.ionRebate2 === "2",
      adder: { adder: "blkRepAdder" },
    },
    {
      condition: proposal.ionRebate2 === "1",
      adder: { adder: "blkCustAdder" },
    },
    {
      condition: proposal.panelBonus === "2",
      adder: { adder: "panelBonusRep" },
    },
    {
      condition: proposal.panelBonus === "1",
      adder: { adder: "panelBonusCust" },
    },
    {
      condition: +proposal.battery10 > 0 && +proposal.battery10 < 11,
      adder: {
        adder: "battery10",
        quantity: 1,
        amount: battery10Amount * dealerFee,
      },
    },
    {
      condition: +proposal.battery10 > 1 && +proposal.battery10 < 11,
      adder: {
        adder: "battery10Add",
        quantity: +proposal.battery10 - 1,
        amount: 12500 * dealerFee,
      },
    },
    {
      condition: !!+proposal.expansionPack,
      adder: {
        adder: "expansionPack",
        quantity: +proposal.expansionPack,
        amount: +proposal.expansionPackAmount * dealerFee,
      },
    },
    {
      condition: +proposal.battery10 > 20 && +proposal.battery10 < 31,
      adder: {
        adder: "battery10c",
        quantity: +proposal.battery10 - 20,
        amount: (battery10Amount * dealerFee) / (+proposal.battery10 - 20),
      },
    },
    {
      condition: +proposal.battery10 >= 11 && +proposal.battery10 < 20,
      adder: {
        adder: "powerWall",
        quantity: +proposal.battery10 - 10,
        amount: battery10Amount * dealerFee,
      },
    },
    {
      condition: proposal.msp === "1" || proposal.msp === "2",
      adder: { adder: "msp", amount: mspAmount },
    },
    {
      condition: proposal.freeMonths === "1",
      adder: { adder: "freeMonths", amount: freePowerAmount },
    },
    {
      condition: proposal.utility === "Salt River Project (SRP)",
      adder: { adder: "loadSwitch", amount: 1500 },
    },
    {
      condition: proposal.freeMonths === "2",
      adder: { adder: "freeMonthsRep", amount: freePowerAmount },
    },
    {
      condition: proposal.ballast === "1",
      adder: {
        adder: "ballast",
        amount: proposal.ballastModules * proposal.modSize * ballastAmount,
      },
    },
    {
      condition: proposal.critterGuard === "1",
      adder: {
        adder: "critterGuard",
        amount: proposal.systemSize * critterGuardAmount,
      },
    },
    {
      condition: proposal.treeTrim === "1",
      adder: {
        adder: "treeRemoval",
        amount: proposal.treeTrimAmount * dealerFee,
      },
    },
    {
      condition: +proposal.reroof > 0,
      adder: { adder: "reroof", amount: proposal.reroofAmount * dealerFee },
    },
    {
      condition: !!+proposal.utilityReview,
      adder: {
        adder: "utilityReview",
        amount: proposal.utilityReviewAmount * dealerFee,
      },
    },
    {
      condition: proposal.groundMount === "1",
      adder: {
        adder: "groundMount",
        amount:
          proposal.groundMountModules * proposal.modSize * groundMountAmount,
      },
    },
    {
      condition: proposal.travel === "1",
      adder: {
        adder: "travel",
        amount: proposal.systemSize * proposal.travelAmount,
      },
    },
    {
      condition: proposal.pSolar === "1",
      adder: {
        adder: "poolSolar",
        amount: proposal.systemSize * pSolarAmount,
      },
    },
    {
      condition: +proposal.military > 0,
      adder: { adder: "repMilitary", amount: proposal.military },
    },
    {
      condition: proposal.miscCash === "1",
      adder: {
        adder: "miscCash",
        amount: proposal.miscCashAmount,
        notes: proposal.miscCashNotes,
      },
    },
    {
      condition: proposal.blackFriday === "1",
      adder: { adder: "blackFriday" },
    },
    {
      condition: proposal.blackFriday === "2",
      adder: { adder: "christmas" },
    },
    {
      condition: +proposal.security > 0,
      adder: { adder: "security", amount: proposal.security_amount },
    },
    {
      condition: +proposal.acCoupled > 0,
      adder: { adder: "acCoupled", quantity: proposal.acCoupled },
    },
    {
      condition: true,
      adder: {
        adder: "travelAdder",
        amount: (customer.travelAdder * proposal.systemSize) / +dealerFee,
        tier:
          +customer.travelDistance < 76
            ? ""
            : +customer.travelDistance <= 100
            ? "Tier 1: 76-100 Miles"
            : +customer.travelDistance <= 125
            ? "Tier 2: 101-125 Miles"
            : "Tier 3: 126-150 Miles",
      },
    },
    {
      condition: proposal.ionRebate === "3",
      adder: {
        adder: "setterCashBonus",
      },
    },
    {
      condition: proposal.waterSoftener === "1",
      adder: {
        adder: "waterSoftener",
        amount: proposal.waterSoftenerAmount,
      },
    },
  ];
};

export { getAdditionalAdders };
